import { gsap, isTouchDevice, prefersReducedMotion } from '@/animations/gsap'

const handlers = new WeakMap()

// v-magnetic o v-magnetic="0.4": el elemento sigue un poco al mouse.
export default {
  inserted(el, binding) {
    if (isTouchDevice() || prefersReducedMotion()) return
    const strength = typeof binding.value === 'number' ? binding.value : 0.3
    const moveX = gsap.quickTo(el, 'x', { duration: 0.6, ease: 'power3.out' })
    const moveY = gsap.quickTo(el, 'y', { duration: 0.6, ease: 'power3.out' })
    let center = { x: 0, y: 0 }

    const onEnter = () => {
      const r = el.getBoundingClientRect()
      const x = Number(gsap.getProperty(el, 'x'))
      const y = Number(gsap.getProperty(el, 'y'))
      center = { x: r.left - x + r.width / 2, y: r.top - y + r.height / 2 }
    }
    const onMove = (e) => {
      if (e.pointerType !== 'mouse') return
      moveX((e.clientX - center.x) * strength)
      moveY((e.clientY - center.y) * strength)
    }
    const onLeave = () => {
      moveX(0)
      moveY(0)
    }

    el.addEventListener('pointerenter', onEnter)
    el.addEventListener('pointermove', onMove)
    el.addEventListener('pointerleave', onLeave)
    handlers.set(el, { onEnter, onMove, onLeave })
  },
  unbind(el) {
    const h = handlers.get(el)
    if (!h) return
    el.removeEventListener('pointerenter', h.onEnter)
    el.removeEventListener('pointermove', h.onMove)
    el.removeEventListener('pointerleave', h.onLeave)
    gsap.killTweensOf(el)
    handlers.delete(el)
  }
}
